export default {"src":"/_next/static/media/payment-giropay.edf7aa20.svg","height":16,"width":24,"blurWidth":0,"blurHeight":0};